import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63e5b7de")

_pushScopeId("data-v-63e5b7de")
const _hoisted_1 = {
  class: "container products-page",
  id: "products"
}
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = {
  class: "d-lg-flex",
  style: {"margin-top":"50px"}
}
const _hoisted_4 = { class: "products-actions order-lg-1 col-lg-2 mb-lg-0 justify-content-center justify-content-lg-center" }
const _hoisted_5 = {
  class: "product-circle-btn btn-lred flex-center",
  type: "button"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_7 = { class: "products-search col-lg-5 mt-auto" }
const _hoisted_8 = { class: "search-button-wrapper pl-15" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_10 = { class: "products-total-filter col-lg-5 mt-auto px-lg-2" }
const _hoisted_11 = {
  class: "products-total order-lg-1",
  style: {"height":"48px"}
}
const _hoisted_12 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "products-filter-circle"
}
const _hoisted_15 = { class: "desktop-grid w100" }
const _hoisted_16 = { class: "w100" }
const _hoisted_17 = { style: {"width":"10%"} }
const _hoisted_18 = { style: {"width":"10%"} }
const _hoisted_19 = { style: {"width":"5%"} }
const _hoisted_20 = { class: "thead-cell-center" }
const _hoisted_21 = { style: {"width":"5%"} }
const _hoisted_22 = { class: "thead-cell-center" }
const _hoisted_23 = { style: {"width":"5%"} }
const _hoisted_24 = { class: "thead-cell-center" }
const _hoisted_25 = { style: {"width":"5%","padding-inline-end":"10px"} }
const _hoisted_26 = { class: "thead-cell-center" }
const _hoisted_27 = {
  class: "desktop-table-action",
  style: {"width":"7%"}
}
const _hoisted_28 = { class: "thead-cell-center" }
const _hoisted_29 = { class: "desktop-table-text-setting" }
const _hoisted_30 = { class: "desktop-table-text-setting" }
const _hoisted_31 = { class: "desktop-table-text-setting" }
const _hoisted_32 = { class: "desktop-table-text-setting" }
const _hoisted_33 = { class: "desktop-table-text-setting" }
const _hoisted_34 = { class: "desktop-table-text-setting" }
const _hoisted_35 = { class: "desktop-table-text-setting text-center" }
const _hoisted_36 = {
  key: 0,
  class: "icon-f icon-check fs-16 no-pointer"
}
const _hoisted_37 = {
  key: 1,
  class: "icon-f icon-delete-cross fs-16 no-pointer",
  style: {"color":"#fd695a"}
}
const _hoisted_38 = { class: "desktop-table-text-setting text-center" }
const _hoisted_39 = {
  key: 0,
  class: "icon-f icon-check fs-16 no-pointer"
}
const _hoisted_40 = {
  key: 1,
  class: "icon-f icon-delete-cross fs-16 no-pointer",
  style: {"color":"#fd695a"}
}
const _hoisted_41 = { class: "desktop-table-text-setting text-center" }
const _hoisted_42 = {
  key: 0,
  class: "icon-f icon-check fs-16 no-pointer"
}
const _hoisted_43 = {
  key: 1,
  class: "icon-f icon-delete-cross fs-16 no-pointer",
  style: {"color":"#fd695a"}
}
const _hoisted_44 = {
  class: "desktop-table-text-setting",
  style: {"padding-inline-start":"14px"}
}
const _hoisted_45 = {
  class: "desktop-table-text-setting text-center",
  style: {"padding-inline-start":"14px","padding-inline-end":"10px"}
}
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_47 = { class: "desktop-table-action text-center" }
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
const _hoisted_49 = {
  key: 0,
  class: "mobile-grid"
}
const _hoisted_50 = { class: "header-line" }
const _hoisted_51 = { class: "not-active-title-wrapper" }
const _hoisted_52 = {
  key: 0,
  class: "not-active-title"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_54 = { class: "mobile-table-info-card" }
const _hoisted_55 = { class: "details-row" }
const _hoisted_56 = { class: "details-row" }
const _hoisted_57 = { class: "details-row" }
const _hoisted_58 = { class: "details-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('navbar.catalog')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          class: "product-circle-btn btn-orange flex-center not-confirmed-btn",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setNotConfirmedFilter && _ctx.setNotConfirmedFilter(...args)))
        }, _toDisplayString(_ctx.$t('button.notConfirmedImages')), 1),
        _createVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('button.newProduct')), 1),
        _createVNode("button", {
          type: "button",
          class: "product-circle-btn btn-green mx-1",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportProducts && _ctx.exportProducts(...args)))
        }, [
          _hoisted_6,
          _createVNode("div", null, _toDisplayString(_ctx.$t('report.export')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("input", {
          class: "bookit-input provider-input w100",
          type: "text",
          placeholder: _ctx.$t('placeholder.searchByOptionName'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.keyword = $event)),
          onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.getProducts()), ["enter"]))
        }, null, 40, ["placeholder"]), [
          [_vModelText, _ctx.filter.keyword]
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getProducts()))
          }, [
            _hoisted_9
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('products.totalProducts')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('catalog.ofProds', { total: _ctx.total })), 1)
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("span", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]),
        _createVNode("div", {
          class: ["products-filter", { hasFilter: _ctx.hasFilter }]
        }, [
          _createVNode("button", {
            type: "button",
            class: "products-filter-btn-text",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goProductsFilter()))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
            _hoisted_13
          ]),
          (_ctx.hasFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_14, "!"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("table", _hoisted_16, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            _createVNode("td", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortBy('Id'))),
              style: {"width":"10%"}
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('catalog.productId')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Id')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", _hoisted_17, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('catalog.productHashId')), 1)
            ]),
            _createVNode("td", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortBy('Name'))),
              style: {"width":"13%"}
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('product.productName')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Name')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortBy('ProviderId'))),
              style: {"width":"8%"}
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('catalog.providerId')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderId')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortBy('Provider'))),
              style: {"width":"14%"}
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('catalog.providerName')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Provider')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", _hoisted_18, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('catalog.providerHashId')), 1)
            ]),
            _createVNode("td", _hoisted_19, [
              _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('catalog.photos')), 1)
            ]),
            _createVNode("td", _hoisted_21, [
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('catalog.slot')), 1)
            ]),
            _createVNode("td", _hoisted_23, [
              _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('catalog.price-list')), 1)
            ]),
            _createVNode("td", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortBy('ProductType'))),
              style: {"width":"10%","padding-inline-start":"14px"}
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('product.productType')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProductType')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", _hoisted_25, [
              _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('catalog.b2cLink')), 1)
            ]),
            _createVNode("td", _hoisted_27, [
              _createVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('customerType.actions')), 1)
            ])
          ])
        ]),
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
            return (_openBlock(), _createBlock("tr", {
              class: product.active === false ? 'deactivated-marker' : '',
              key: product.idNoHash,
              style: {"position":"relative"}
            }, [
              _createVNode("td", _hoisted_29, _toDisplayString(product.idNoHash), 1),
              _createVNode("td", _hoisted_30, _toDisplayString(product.id), 1),
              _createVNode("td", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: { name: 'product', params: { id: product.idNoHash } },
                  class: "text-link cuted-cell m-0"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(product.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createVNode("td", _hoisted_32, _toDisplayString(product.providerIdNoHash), 1),
              _createVNode("td", _hoisted_33, [
                _createVNode(_component_router_link, {
                  to: { name: 'provider-view', params: { id: product.providerIdNoHash } },
                  class: "text-link cuted-cell m-0"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(product.providerName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createVNode("td", _hoisted_34, _toDisplayString(product.providerId), 1),
              _createVNode("td", _hoisted_35, [
                (product.hasImages)
                  ? (_openBlock(), _createBlock("i", _hoisted_36))
                  : (_openBlock(), _createBlock("i", _hoisted_37))
              ]),
              _createVNode("td", _hoisted_38, [
                (product.hasSlot)
                  ? (_openBlock(), _createBlock("i", _hoisted_39))
                  : (_openBlock(), _createBlock("i", _hoisted_40))
              ]),
              _createVNode("td", _hoisted_41, [
                (product.hasPriceList)
                  ? (_openBlock(), _createBlock("i", _hoisted_42))
                  : (_openBlock(), _createBlock("i", _hoisted_43))
              ]),
              _createVNode("td", _hoisted_44, _toDisplayString(product.productType), 1),
              _createVNode("td", _hoisted_45, [
                (product.onAir)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      style: {"color":"#42aee7"},
                      href: `https://www.bookit.fun/product?productID=${product.id}`,
                      class: !product.active ? 'link-disabled' : '',
                      target: "_blank"
                    }, [
                      _hoisted_46
                    ], 10, ["href"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("td", _hoisted_47, [
                _createVNode(_component_router_link, {
                  to: { name: 'product', params: { id: product.idNoHash } },
                  class: "m-0"
                }, {
                  default: _withId(() => [
                    _hoisted_48
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    (_ctx.products && _ctx.products.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_49, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "product-item",
              key: index
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'product', params: { id: product.idNoHash } }
              }, {
                default: _withId(() => [
                  _createVNode("a", _hoisted_50, [
                    _createVNode("span", null, _toDisplayString(product.id), 1),
                    _createVNode("span", _hoisted_51, [
                      (!product.active)
                        ? (_openBlock(), _createBlock("div", _hoisted_52, _toDisplayString(_ctx.$t('product.notActive')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("span", {
                      class: "calendar-circle",
                      style: 'background:' + product.calendarColor
                    }, null, 4)
                  ]),
                  _hoisted_53,
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('product.productName')) + ": ", 1),
                      _createVNode("span", null, _toDisplayString(product.name), 1)
                    ]),
                    _createVNode("div", _hoisted_56, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('product.productType')) + ": ", 1),
                      _createVNode("span", null, _toDisplayString(product.productType), 1)
                    ]),
                    _createVNode("div", _hoisted_57, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('catalog.providerName')) + ": ", 1),
                      _createVNode("span", null, _toDisplayString(product.providerName), 1)
                    ]),
                    _createVNode("div", _hoisted_58, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('catalog.providerId')) + ": ", 1),
                      _createVNode("span", null, _toDisplayString(product.providerIdNoHash), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
})